/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ErrorInputs */

const en_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fr_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur`)
};

const de_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const it_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore`)
};

const ru_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

const es_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const zh_cn2_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const ja_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const hi_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलती`)
};

const pt_pt2_error = /** @type {(inputs: ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error = /** @type {((inputs?: ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error(inputs)
	if (locale === "de") return de_error(inputs)
	if (locale === "it") return it_error(inputs)
	if (locale === "ru") return ru_error(inputs)
	if (locale === "es") return es_error(inputs)
	if (locale === "zh-CN") return zh_cn2_error(inputs)
	if (locale === "ja") return ja_error(inputs)
	if (locale === "hi") return hi_error(inputs)
	if (locale === "pt-PT") return pt_pt2_error(inputs)
	return en_error(inputs)
});